<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">{{ contractorRegion.name }}</h4>
            </div>
            <edit-button @edit-click="editContractorRegion"></edit-button>
          </md-card-header>
          <md-card-content
            ><p>
              <strong>Contractor</strong><br />
              <router-link :to="{ name: 'Contractor' }">
                {{ contractor.name }}
              </router-link>
            </p>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Contractor Contact</h4>
            </div>
            <add-button @add-click="addContractorContact"></add-button>
          </md-card-header>
          <md-card-content>
            <contactList></contactList>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ContactList from "../contractor-contacts/ContractorContactsList";

export default {
  components: {
    ContactList
  },
  computed: {
    ...mapGetters({
      contractorRegion: "data-management-contractor/region",
      contractor: "data-management-contractor/contractor"
    })
  },
  async created() {
    this.$store.dispatch(
      "data-management-contractor/getContractorRegionDetails",
      this.$route.params.regionId
    );
  },
  methods: {
    addContractorContact() {
      this.$router.push({ name: "Add Contractor Contact" });
    },
    editContractorRegion() {
      this.$router.push({
        name: "Edit Contractor Region",
        params: { regionId: this.contractorRegion.id }
      });
    }
  }
};
</script>

<style></style>
